import React, { useEffect, useState } from "react";
import Modal from 'react-modal';
import axios from "axios";
import { toast } from "react-toastify";
import { PutObjectCommand, S3 } from "@aws-sdk/client-s3";
import { useNavigate } from "react-router-dom";
import XMLParser from 'react-xml-parser';
import { useTranslation } from "react-i18next";

import { useReception } from '../../ReceptionContext';
import CrossIcon from '../../assets/images/crossIcon.png';
import MasterCard from "../../assets/images/visa.png";
import VisaCard from "../../assets/images/master.png";

import TabelaeKorsise4 from '../../assets/images/TabelaeKorsise.4.jpg';
import TabelaeKorsise5 from '../../assets/images/TabelaeKorsise.5.jpg';
import shkollaveroreenotit from '../../assets/images/fitensi.jpg';
import KidsFitnes from '../../assets/images/fitensi.jpg';

import Shkollaenotit from '../../assets/images/shkolla-e-notit.jpg';
import { FaDownload } from 'react-icons/fa';  // Import the download icon from react-icons

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        outerHeight: '100px',
        border: 'none',
        borderRadius: '24px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        padding: '0',
        maxWidth: '600px',
        width: '90%'
    },
};

export const Contract = ({ step, setStep, formData, registrations, setRegistrations, setFormData,form, setForm }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { centerId } = useReception();
    const [orderID, setOrderID] = useState(null);
    const [sessionID, setSessionID] = useState(null);
    const [display, setDisplay] = useState('Terms');

    // useEffect(() => {
    //     if(step === 2 && registrations && registrations.length > 0) {

    //         if(registrations[0]?.type == "Individual") {
    //             // Define discount percentage based on total registrations
    //             const discountPercentage = registrations.length > 3 ? 20 : registrations.length > 2 ? 15 : 0; // 20% discount for 3 registrations, 15% for more than 2
        
    //             // Create a new array with updated registration objects
    //             const updatedRegistrations = registrations.map(registration => ({
    //                 ...registration, // Retain all existing fields
    //                 discount: discountPercentage,
    //                 payableAmount: registration.totalAmount - (registration.totalAmount * (discountPercentage / 100))
    //             }));
        
    //             // Update the state with the new array (assuming you have a setRegistrations function)
    //             setRegistrations(updatedRegistrations);
    //         } else if (registrations[0]?.type == "Shkolla e Notit") {
    //             // Define discount percentage based on total registrations
    //             const discountPercentage = registrations.length > 3 ? 15 : registrations.length > 1 ? 10 : 0; // 20% discount for 3 registrations, 15% for more than 2
    //             // Create a new array with updated registration objects
    //             const updatedRegistrations = registrations.map(registration => ({
    //                 ...registration, // Retain all existing fields
    //                 discount: discountPercentage,
    //                 payableAmount: registration.totalAmount - (registration.totalAmount * (discountPercentage / 100))
    //             }));
        
    //             // Update the state with the new array (assuming you have a setRegistrations function)
    //             setRegistrations(updatedRegistrations);
    //         }
    //     }
    // }, [step]);

    const handlePaymentMethodClick = (method) => {
        const updatedRegistrations = registrations.map(registration => ({
            ...registration,
            paymentMethod: method
        }));

        setRegistrations(updatedRegistrations);
    };

    const handleRegistration = async () => {
        try {
            // Stamp each registration with the customer's currently-selected
            // reception so the backend records it under the right center.
            const requestBody = registrations.map((r) => ({ ...r, center: centerId }));
            let response;
            if (registrations[0]?.type === "Summer School") {
                response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/summerschool/register`, requestBody);
            } else if (registrations[0]?.type === "Daily Pass") {
                response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/dailypass/register`, requestBody);
            } else if (registrations[0]?.type === "Shkolla e Notit") {
                response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/swimmingschool/register`, requestBody);
            } else {
                response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/registeration/register`, requestBody);
            }

            setRegistrations([]);
            setFormData({
                firstName: '',
                lastName: '',
                dateOfBirth: '',
                address: '',
                phone: '',
                email: '',
                time: 0,        //months or appointments per week(kids fitness)
                timings: '',    //for kids fitness
                days: [],       //for kits fitness
                totalAmount: 0,
                payableAmount: 0,
                discount: 0,
                kidEntries: 0,
                swimmingExpertise: '',
                healthProblems: null,
                healthProblemDescription: '',
                type: 'Individual',
                premium: false,
                batchId: '0',
                paymentMethod: '',
                entries: '',
                ageGroup: '',
                age: 0,
                gender: ""

            });
            setForm("Individual")

            toast.success('Registration Successful');
            return response.data;
        } catch (error) {
            console.error('Error adding the user:', error.message);
            toast.error('Registration Failed. ', error.message);
        }
    };

    function getDateAfterMonths(months) {
        const currentDate = new Date();
        const futureDate = new Date(currentDate);
        futureDate.setMonth(currentDate.getMonth() + months);
        const formattedDate = futureDate.toISOString().split('T')[0];
        return formattedDate;
    }

    const [date, setDate] = useState();
    const [currentDate, setCurrentDate] = useState();

    useEffect(() => {
        if (registrations && registrations.length > 0) {
            const date = getDateAfterMonths(registrations[0].time ? registrations[0].time : 0);
            const currentDate = new Date();
            const formattedCurrentDate = currentDate.toISOString().split('T')[0];
            setCurrentDate(formattedCurrentDate);
            setDate(date);
        }
    }, [registrations]);

    const [modalIsOpen, setIsOpen] = useState(false);
    function openModal() {
        setIsOpen(true);
        setPaymentMethod('card'); // Set card as default payment method
        handlePaymentMethodClick("card"); // Set card payment method for registrations
    }
    function closeModal() {
        setIsOpen(false);
    }

    const handlePayment = async () => {
        const registration = await handleRegistration();

        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/registeration/makePayment`, {
            email: registrations[0]?.email,
            phone: registrations[0]?.phone,
            amount: getPayableAmount(),
            registrationId: registration[0]._id,

        });

        const jsonObj = new XMLParser().parseFromString(response.data);
        const url = jsonObj.getElementsByTagName('URL')[0].value;
        const orderId = jsonObj.getElementsByTagName('OrderID')[0].value;
        setOrderID(orderId);
        localStorage.setItem('orderID', orderId);
        const sessionId = jsonObj.getElementsByTagName('SessionID')[0].value;
        localStorage.setItem('sessionID', sessionId);
        setSessionID(sessionId);

        window.location.href = `${url}?ORDERID=${orderId}&SESSIONID=${sessionId}`;
    };



    const getTotalAmount = () => {
        const totalAmount = registrations?.reduce((acc, registration) => acc + registration.totalAmount, 0);
        return totalAmount;
    };

    const getPayableAmount = () => {
        const payableAmount = registrations?.reduce((acc, registration) => acc + registration.payableAmount, 0);
        return payableAmount;
    };

    const [paymentMethod, setPaymentMethod] = useState('');

    return (
        <div className={`lg:w-[80vw] w-[90vw] min-h-[100vh] bg-white rounded-3xl pt-10 pb-10 mb-10 flex flex-col font-custom2 shadow-2xl border-4 border-gray-100 ${display == "Terms" ? 'lg:px-20 px-5' : 'px-5'}`}>
            {
                display == "Terms"
                    ? <TermsAndContitions currentDate={currentDate} date={date} />
                    : registrations[0]?.type == "Individual" ? <IndividualSchedual />
                        : registrations[0]?.type == "Shkolla e Notit" ? <SwimmingSchool />
                            : (registrations[0]?.type == "kids fitness" || registrations[0]?.type == "Kids Fitness" || registrations[0]?.type == "Adults") ? <KidsFitness />
                                : <ParentsGuidlines />
            }

            <div className="flex flex-row items-end justify-end w-full gap-4 mt-12 mb-8 px-4 sm:px-8 lg:px-20">
                <button
                    onClick={() => {
                        if (display == "Schedual") {
                            setDisplay("Terms");
                        } else {
                            setStep(1);
                        }
                    }}
                    className="px-8 py-3 text-gray-700 font-semibold transition-all duration-200 bg-gray-100 border-2 border-gray-300 rounded-xl max-w-fit hover:bg-gray-200 hover:border-gray-400 hover:shadow-md transform hover:scale-105">{t('cancel')}</button>
                <button
                    onClick={() => {
                        if (display == "Terms") {
                            setDisplay("Schedual");
                        } else {
                            openModal();
                        }
                    }}
                    className="px-8 py-3 text-white font-bold transition-all duration-200 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl max-w-fit hover:from-blue-700 hover:to-blue-800 hover:shadow-lg transform hover:scale-105"> {t('accept')}</button>
            </div>
            <Modal
                isOpen={modalIsOpen}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className='flex justify-end w-full'>
                    <img src={CrossIcon} alt='close' className='w-5 h-5 cursor-pointer' onClick={closeModal} />
                </div>
                {
                    <div className={`flex flex-col items-center justify-center gap-4 p-6 px-5 md:px-20 text-center`}>
                            <div className="py-6 w-full border-b-2 border-blue-200 mb-4">
                                <span className={`${getTotalAmount() == getPayableAmount() ? 'hidden' : 'block'} text-blue-700 font-bold p-4 bg-blue-50 border-2 border-blue-300 rounded-xl shadow-md`}>
                                    <div className="flex flex-col gap-2">
                                        <span className="text-sm text-gray-600">{form || registrations[0]?.type || 'Anëtarësim'}</span>
                                        <div className="flex items-center justify-center gap-3">
                                            <span className="text-lg text-gray-500 line-through">{getTotalAmount()}€</span>
                                            <span className="text-2xl font-bold text-blue-700">{getPayableAmount()}€</span>
                                        </div>
                                    </div>
                                </span>
                                <span className={`${getTotalAmount() == getPayableAmount() ? 'block' : 'hidden'} text-blue-700 font-bold p-4 bg-blue-50 border-2 border-blue-300 rounded-xl shadow-md`}>
                                    <div className="flex flex-col gap-2">
                                        <span className="text-sm text-gray-600">{form || registrations[0]?.type || 'Anëtarësim'}</span>
                                        <span className="text-2xl font-bold text-blue-700">{getTotalAmount()}€</span>
                                    </div>
                                </span>
                            </div>
                            <div className="text-blue-700 font-semibold p-4 border-2 border-blue-300 rounded-xl flex flex-row gap-3 w-full justify-between items-center hover:bg-blue-50 transition-colors cursor-pointer shadow-md hover:shadow-lg">
                                <div className="flex flex-row gap-3 items-center">
                                    <input onClick={() => { handlePaymentMethodClick("card"); setPaymentMethod('card'); }} type="radio" id="paymentMethodCard" name="paymentMethod" className="w-5 h-5 cursor-pointer" />
                                    <span className="text-lg">{t('pay_with_card')}</span>
                                </div>
                                <div className="flex flex-row gap-3">
                                    <img src={MasterCard} className="w-10 h-6 object-contain" />
                                    <img src={VisaCard} className="w-10 h-6 object-contain" />
                                </div>
                            </div>
                            <div className="flex flex-row items-end justify-end w-full gap-5 mt-6">
                                <button onClick={async () => {
                                    if (paymentMethod == '') {
                                        toast.warning(t('select_payment_method'));
                                    } else {
                                        closeModal();
                                        setStep(1);
                                        await handlePayment();
                                    }
                                }} className="px-10 py-3 text-white font-bold transition-all duration-200 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl transform hover:scale-105">{t('pay')}</button>
                            </div>
                        </div>
                }
            </Modal>
        </div>
    )
};

const IndividualSchedual = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center justify-center w-full gap-5 md:flex-row">
            <div className="flex flex-col items-center">
                <img src={TabelaeKorsise4}  />
                <a href={TabelaeKorsise4} download="TabelaeKorsise4.jpg" className="flex items-center px-5 py-2 mt-2 text-white transition-all duration-200 bg-blue-600 rounded-lg max-w-fit hover:bg-blue-800 hover:scale-105">
                    {t('download_image')} <FaDownload className="ml-2" />
                </a>
            </div>
            <div className="flex flex-col items-center">
                <img src={TabelaeKorsise5}  />
                <a href={TabelaeKorsise5} download="TabelaeKorsise5.jpg" className="flex items-center px-5 py-2 mt-2 text-white transition-all duration-200 bg-blue-600 rounded-lg max-w-fit hover:bg-blue-800 hover:scale-105">
                    {t('download_image')} <FaDownload className="ml-2" />
                </a>
            </div>
        </div>
    );
};

const ParentsGuidlines = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center justify-center w-full">
            <img src={shkollaveroreenotit} className="sm:w-[90%] lg:w-[50%] w-[100%]" />
            <a href={shkollaveroreenotit} download="shkolla-e-notit.jpg" className="flex items-center px-5 py-2 mt-2 text-white transition-all duration-200 bg-blue-600 rounded-lg max-w-fit hover:bg-blue-800 hover:scale-105">
                {t('download_image')} <FaDownload className="ml-2" />
            </a>
        </div>
    );
};

const SwimmingSchool = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center justify-center w-full">
            <img src={Shkollaenotit} className="sm:w-[90%] lg:w-[50%] w-[100%]" />
            <a href={Shkollaenotit} download="shkollaenotit.jpg" className="flex items-center px-5 py-2 mt-2 text-white transition-all duration-200 bg-blue-600 rounded-lg max-w-fit hover:bg-blue-800 hover:scale-105">
                {t('download_image')} <FaDownload className="ml-2" />
            </a>
        </div>
    );
};

const KidsFitness = () => {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center justify-center w-full">
            <img src={KidsFitnes} className="sm:w-[90%] lg:w-[50%] w-[100%] sm:h-[60vh] lg:h-[70vh] h-[70vh]" />
            <a href={KidsFitnes} download="fitnesi.jpg" className="flex items-center px-5 py-2 mt-2 text-white transition-all duration-200 bg-blue-600 rounded-lg max-w-fit hover:bg-blue-800 hover:scale-105">
                {t('download_image')} <FaDownload className="ml-2" />
            </a>
        </div>
    );
};

const TermsAndContitions = ({ currentDate, date }) => {
    const { t } = useTranslation();

    const formatDate = (dateString) => {
        // Ensure dateString is a valid string
        if (typeof dateString !== 'string') {
          return '';
        }
      
        const parts = dateString?.split('-');
        // Ensure parts has exactly three components: [year, month, day]
        if (parts.length !== 3) {
          return '';
        }
      
        const [year, month, day] = parts;
        return `${day}/${month}/${year}`;
      };
      
    
    return (
        <>
            <div className="flex flex-col items-center justify-center w-full text-center mb-8">
                <div className="flex flex-col w-[90%] sm:w-[65%] lg:w-[45%] items-center justify-center text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">{t("membership_contract")}</h1>
                    <p className="text-gray-600 text-lg">{t("read_carefully")}</p>
                </div>
            </div>
            <div className="flex flex-col w-full px-4 sm:px-8 lg:px-20 mt-10 space-y-6">
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("individual_membership")}</span> {t("individual_membership_text")}
                    </p>
                </div>
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("pool_trainer")}</span> {t("pool_trainer_text")}
                    </p>
                </div>
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("membership_period")}</span> {t("membership_period_text")}
                    </p>
                </div>
                <div className="bg-red-50 border-2 border-red-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-red-700 leading-relaxed">
                        <span className="font-bold text-red-800 text-lg">{t("payment_prices")}</span> {t("payment_prices_text")}
                    </p>
                </div>
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("health_physical_aspect")}</span> {t("health_physical_aspect_text")}
                    </p>
                </div>
                <div className="bg-white border-2 border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("damage_responsibility")}</span> {t("damage_responsibility_text")}
                    </p>
                </div>
                <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-300 rounded-xl p-6 shadow-md">
                    <p className="text-gray-800 leading-relaxed">
                        <span className="font-bold text-blue-700 text-lg">{t("contract_duration")}</span> 
                        <span className="underline font-semibold text-blue-800 mx-1">{formatDate(currentDate)}</span> 
                        {t("to")} 
                        <span className="underline font-semibold text-blue-800 mx-1">{formatDate(date)}</span>
                    </p>
                </div>
            </div>
        </>
    );
};
